module.exports = __webpack_public_path__ + "static/media/40.a3a06b3c.jpg";